// extracted by mini-css-extract-plugin
module.exports = {"wrap":"pull-quote_wrap__Ip3Hz","author":"pull-quote_author__PZXHJ"};